



import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import ImgSlider from "../components/ImgSlider";
import Footer from "../components/Footer";   

const growAnime = keyframes`
  0%{
    transform: scale(0.8);
  }
  100%{
    transform: scale(1);
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10vh;

  @media (max-width:1000px){
    align-items:center;
    gap:4vh;
  }
`;

const LeftTop = styled.div`
  width:50vw;
  height:20vh;
  display:flex;
  align-items:flex-start;
  padding:5vh 0 0 5vw;

  @media (max-width:1000px){
    width:90%;
    height:12vh;
  }
`;

const Title = styled.h1`
  font-size:3em;
  font-weight:600;
  color:var(--secondary);

  @media (max-width:500px){
    font-size:2.5em;
  }
`;

const BotContainer = styled.div`
  width:100%;
  display:flex;
  justify-content:center;
  gap:4vw;
  padding:0 3vw;

  @media (max-width:640px){
    flex-direction:column;
    gap:4vh;
  }
`;

const GalleryDiv = styled.div`
  width:35vw;
  height:60vh;
  border:2vh solid #ffc734;
  border-radius:15px;
  background:#ffc734;
  box-shadow:-5px 5px 5px rgba(0,0,0,0.3);
  display:flex;
  align-items:center;
  justify-content:center;

  @media (max-width:1000px){
    width:80%;
    height:45vh;
  }

  @media (max-width:600px){
    width:94%;
  }
`;

const VideoElem = styled.video`
  width:100%;
  height:100%;
  object-fit:fill;
  cursor:pointer;
  animation:${growAnime} 1s ease-in-out;
`;

const MainGallery = () => {

  const navigate = useNavigate();

  useEffect(()=>{
    window.scrollTo(0,0);
  },[]);

  return (
    <>
      <Wrapper id="main-gallery">

        <LeftTop>
          <Title>Gallery</Title>
        </LeftTop>

        <BotContainer>

       
          <GalleryDiv>
            <VideoElem autoPlay muted onClick={()=>navigate("/videos")}>
              <source src="/videos/intro-video.mp4" type="video/mp4"/>
            </VideoElem>
          </GalleryDiv>

          <GalleryDiv>
            <ImgSlider/>
          </GalleryDiv>

        </BotContainer>

      </Wrapper>

      <Footer/>

    </>
  );
};

export default MainGallery;